import { Mongo } from 'meteor/mongo';

export const INSTANCE_CONFIG_ID = 'instance';
export const INSTANCE_MODES = Object.freeze({
  MULTI: 'multi',
  SOLO: 'solo',
});
export const PUBLIC_INSTANCE_CONFIG_FIELDS = Object.freeze(['mode']);

export const RuntimeConfigCollection = new Mongo.Collection('runtimeConfig');

export function normalizeInstanceMode(value) {
  const mode = String(value || INSTANCE_MODES.MULTI).trim().toLowerCase();
  if (!Object.values(INSTANCE_MODES).includes(mode)) {
    throw new Error('private.instance.mode must be "multi" or "solo".');
  }
  return mode;
}
